module.exports = __webpack_public_path__ + "assets/243b95caa93b15b1417e70e3d5fbf352.png";